var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var Textarea = function (_PureComponent) {
  _inherits(Textarea, _PureComponent);

  function Textarea(props) {
    _classCallCheck(this, Textarea);

    var _this = _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props));

    _this.getTextareaRef = function () {
      return _this.textarea;
    };

    _this._handleChange = function (e) {
      var onChange = _this.props.onChange;

      var value = e.currentTarget.value;

      _this.setState({
        value: value
      });

      onChange && onChange(e);
    };

    _this._handleFocus = function () {
      _this.setState({
        isFocusing: true
      });
    };

    _this._handleBlur = function () {
      var onBlur = _this.props.onBlur;
      var value = _this.state.value;


      _this.setState({
        isFocusing: false
      });
      onBlur && onBlur(value);
    };

    _this.state = {
      isFocusing: false,
      value: props.value || ''
    };
    return _this;
  }

  _createClass(Textarea, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.isControlled && typeof nextProps.value === 'undefined') {
        return;
      }

      if (this.state.value !== nextProps.value) {
        this.setState({ value: nextProps.value });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          error = _props.error,
          require = _props.require,
          description = _props.description,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          rest = _objectWithoutProperties(_props, ['label', 'error', 'require', 'description', 'className']);

      var _state = this.state,
          value = _state.value,
          isFocusing = _state.isFocusing;

      var hasValue = !!value;

      return React.createElement(
        'div',
        {
          className: 'tg_textarea ' + (isFocusing ? 'textarea_focus' : '') + ' ' + (hasValue ? 'tg_textarea_value' : '') + ' ' + (error ? 'error' : '') + ' ' + (className ? className : '') },
        React.createElement(
          'div',
          { className: 'textarea-wrapper' },
          React.createElement('textarea', _extends({
            ref: function ref(node) {
              return _this2.textarea = node;
            },
            value: value || ''
          }, rest, {
            onChange: this._handleChange,
            onFocus: this._handleFocus,
            onBlur: this._handleBlur
          })),
          React.createElement(
            'div',
            { className: 'textarea_title' },
            label + ' ' + (require ? '*' : '')
          )
        ),
        React.createElement('div', { className: 'bottom-line' }),
        error && React.createElement(
          'div',
          { className: 'error-message' },
          error
        ),
        !error && description && React.createElement(
          'div',
          { className: 'textarea_description' },
          description
        )
      );
    }
  }]);

  return Textarea;
}(PureComponent);

Textarea.propTypes = {
  /** Label with text that goes under the text input */
  label: PropTypes.string,
  /** Error message to display */
  error: PropTypes.string,
  /** Name of the input */
  name: PropTypes.string,
  /** The amount of rows */
  rows: PropTypes.number,
  /** Max length of characters that is allowed */
  maxLength: PropTypes.number,
  /** Disables the input field if true */
  disabled: PropTypes.bool,
  /** Determines if the input is required for the user */
  require: PropTypes.bool,
  /** Placeholder text to display inside the text area */
  placeholder: PropTypes.string,
  /** Description that goes under the label and text area */
  description: PropTypes.string,
  /** Class names for the input */
  className: PropTypes.string
};

Textarea.defaultProps = {
  label: '',
  error: '',
  name: '',
  rows: 3,
  disabled: false,
  require: false,
  placeholder: '',
  description: '',
  className: ''
};

export default Textarea;